module.exports = __webpack_public_path__ + "img/carrefour_frontenac.072b88ca.webp";